import { defineNuxtPlugin, useHead, useRoute } from "#imports";


export default defineNuxtPlugin((nuxtApp) => {
	if (process.client) {
		// const route = useRoute();
		// const enabledRoutes = ['/lp/anima','/lp/fmu'];
		// const runtimeConfig = useRuntimeConfig();
		// const appEnv = runtimeConfig.appEnv;
		// if (appEnv === 'prod') {
		// 	useHead(
		// 		{
		// 			script: [
		// 				{
		// 					hid: 'optinmonster',
		// 					children: `
		// 					(function(d,u,ac){var s=d.createElement('script');s.type='text/javascript';s.src='https://a.omappapi.com/app/js/api.min.js';s.async=true;s.dataset.user=u;s.dataset.account=ac;d.getElementsByTagName('head')[0].appendChild(s);})(document,289654,307699);
		// 					`,
		// 				}
		// 			]
		// 		}
		// 	);
		// }
	}
});
